








































































































































































import {QSS3ChannelDetails, S3BucketChannelDetails} from '@/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import GenericButton from '@/components/GenericButton.vue';
@Component({
  components: {GenericButton},
})
export default class QuicksightS3Integration extends Vue {
  @Prop() private integrationDetails!: QSS3ChannelDetails;
  private authType: string = 'crossAccount';
  private step: number = 1;
  private externalId: string = `daizy_${Math.floor(Math.random() * 100000)}`;
  private showSecret: boolean = false; // TODO: Temporary, but needs to be addressed correctly
  private readonly rules: any = {
    required: (value: string) => !!value || 'This field is required.',
  };
  private policy = {
    Version: '2012-10-17',
    Statement: [
      {
        Effect: 'Allow',
        Action: [
          's3:PutObject',
        ],
        Resource: '',
      },
    ],
  };
  private readonly awsRegions: string[] = [
    'us-east-2',
    'us-east-1',
    'us-west-1',
    'us-west-2',
    'af-south-1',
    'ap-east-1',
    'ap-southeast-3',
    'ap-south-1',
    'ap-northeast-3',
    'ap-northeast-2',
    'ap-southeast-1',
    'ap-southeast-2',
    'ap-northeast-1',
    'ca-central-1',
    'eu-central-1',
    'eu-west-1',
    'eu-west-2',
    'eu-south-1',
    'eu-west-3',
    'eu-north-1',
    'me-south-1',
    'sa-east-1',
  ];
  @Watch( 'authType' )
  private onAuthTypeChange() {
    if ( this.authType === 'crossAccount' ) {
      this.integrationDetails.accessKeyId = '';
      this.integrationDetails.secretAccessKey = '';
      this.integrationDetails.externalId = this.externalId;
    } else if ( this.authType === 'accessKey' ) {
      this.integrationDetails.roleARN = '';
      this.integrationDetails.externalId = '';
    }
  }

  @Watch( 'integrationDetails.bucketName' )
  private onBucketNameChange() {
    this.policy.Statement[0].Resource = `arn:aws:s3:::${this.integrationDetails.bucketName}/*`;
  }

  private beforeMount() {
    if (this.integrationDetails && this.integrationDetails.externalId) {
      this.authType = 'crossAccount';
      this.policy.Statement[0].Resource = `arn:aws:s3:::${this.integrationDetails.bucketName}/*`;
    } else {
      this.authType = 'accessKey';
    }
  }
}
